import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Join.css";

const Join = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");

  return (
    <div className="outer-container">
      <div className="inner-container">
        <h1 className="heading">Join</h1>
        <div className="">
          <input
            type="text"
            placeholder="Name"
            className="form-control"
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
        </div>
        <div className="">
          <input
            type="text"
            placeholder="Room"
            className="form-control mt-20"
            onChange={(event) => {
              setRoom(event.target.value);
            }}
          />
        </div>
        <Link
          onClick={(event) => (!name || !room ? event.preventDefault() : null)}
          to={`/chat?name=${name}&room=${room}`}
        >
          <button className="btn mt-20" type="submit">
            Sign In
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Join;
